import React from 'react';
import Spinner from 'react-bootstrap/Spinner';

/** Props der LoadingSpinner-Komponente. */
interface LoadingSpinnerProps {
  /** Eindeutige HTML-ID des Spinner-Elements (Projektstandard, stabile E2E-Selektoren). */
  readonly id: string;
}

/**
 * Gemeinsamer Lade-Spinner (Bootstrap border-Spinner in Primaerfarbe).
 * Wird u. a. in ProtectedRoute, LoginPage und AuthCallbackPage verwendet;
 * die aufrufende Komponente ist fuer Zentrierung/Layout zustaendig.
 */
function LoadingSpinner({ id }: LoadingSpinnerProps): React.JSX.Element {
  return <Spinner id={id} animation="border" variant="primary" role="status" />;
}

export default LoadingSpinner;
